module.exports = __webpack_public_path__ + "static/media/clear_day.2ec852f0.svg";